import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import {ANNOTATION_SESSION_ENDPOINT, AWS_LAMBDA_ENDPOINT} from "../utils/constants";
import { tokenStore } from '../utils/tokenStore';
import { authFetch } from "../utils/authFetch";
import { normalizeUserAnnotatorAssignments } from "../utils/annotatorAssignment";

const AuthContext = createContext({
    isAdminMode: false,
    setIsAdminMode: () => {},
    allUsers: null,
    allUserRoles: null
});

export const CustomAuthProvider = ({ children }) => {
    const auth = useAuth();
    const [userData, setUserData] = useState(null);
    const [isAdminMode, setIsAdminMode] = useState(false);
    const [allUsers, setAllUsers] = useState(null);
    const [allUserRoles, setAllUserRoles] = useState(null);

    useEffect(() => {
        const fetchUserData = async () => {
            if (auth.isAuthenticated && auth.user?.profile?.email) {
                try {
                    const email = auth.user.profile.email;
                    const res = await authFetch(
                        `${ANNOTATION_SESSION_ENDPOINT}/getUser?user_id=${encodeURIComponent(email)}`,
                        {},
                        auth.user?.id_token
                    );
                    // console.log("auth user data: ", auth.user.profile);
                    if (!res.ok) throw new Error("Failed to fetch user data");
                    const data = await res.json();
                    // console.log("User data:", data);
                    setUserData(normalizeUserAnnotatorAssignments(data));
                } catch (err) {
                    console.error("Error fetching user data:", err);
                }
            }
        };
        fetchUserData();
        // set user token
        if (auth.isAuthenticated) {
            tokenStore.set(auth.user?.id_token);
          } else {
            tokenStore.set(null);
        }
    }, [auth, isAdminMode]);

    // fetch all users if admin
    useEffect(() => {
        const roles = userData?.roles || [];
        if (
            (isAdminMode && (roles.includes("ADMIN") || roles.includes("ROOT")))
        ) {
          authFetch(`${AWS_LAMBDA_ENDPOINT}/fetchAllUsers`)
            .then(r => {
              if (!r.ok) throw new Error(r.statusText);
              return r.json();
            })
            .then(data => {
                // console.log("✅ fetched all users:", data);
                setAllUsers(data);
            })
            .catch(err => {
              console.error("Failed to load all users:", err);
              setAllUsers([]);
            });

            authFetch(`${AWS_LAMBDA_ENDPOINT}/listAllUsers`)
                .then(r => {
                    if (!r.ok) throw new Error(r.statusText);
                    return r.json();
                })
                .then(data => {
                    // console.log("✅ fetched all user roles: ", data.users);
                    setAllUserRoles(data.users);
                })
                .catch(err => {
                    console.error("Failed to load user roles: ", err);
                    setAllUserRoles([]);
                })
        }
      }, [userData, isAdminMode]);

    return (
        <AuthContext.Provider value={{ userData, setUserData, isAdminMode, setIsAdminMode, allUsers, allUserRoles }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useCustomAuth = () => useContext(AuthContext);
